// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".external[data-v-39222bd6]:after{content:\" ↗\"}", "",{"version":3,"sources":["webpack://./DefaultParameter.vue","webpack://./src/Components/Parameters/DefaultParameter.vue"],"names":[],"mappings":"AAAA,iCCCA,YACC","sourcesContent":[".external:after{content:\" ↗\"}","\n.external:after {\n\tcontent: ' ↗';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
